import { IntlShape } from "react-intl";
import { messages } from "./IntroPage.messages"; //TODO: fetch this from lesson intl instead

import { ChapterLesson, CourseChapter } from "@jelly/lesson";
//import { course01EN } from "@src/lms/data/course/course-en";
import { availableChapters } from "@src/components/page-template/data";

export interface Data {
  sections: Section[];
}

export interface Section {
  title: string;
  mainItem?: SectionItem;
  courses: SectionItem[];
}

export interface SectionItem {
  id: string;
  title: string;
  number: string;
  description: string;
  button?: {
    title: string;
    href: string;
    disabled?: boolean;
  };
  muted: boolean;
  subsection?: {
    title: string;
    items: SubItem[];
  };
}

export interface SubItem {
  title: string;
  number: string;
  disabled?: boolean;
  href?: string;
}

export const prepareIntroData = ({ intl }: { intl: IntlShape }): Data => {
  //const courseOneChapers = course01EN.chapters;

  const chapters: SectionItem[] = availableChapters(intl).map((chapter: CourseChapter) => {
    const chapterNrInt = chapter.publicId;

    let button = {
      disabled: true,
      href: "#",
      title: intl.formatMessage(messages[`buttonGoToLessonSoon`], { lessonNr: `${chapterNrInt}.1` }),
    };

    //If chapter has first lesson
    if (chapter.chapterLessons[0]?.lesson?.id) {
      button = {
        disabled: false,
        href: `/course/spatial-audio/${chapter.chapterLessons[0].lesson.id}`,
        title: intl.formatMessage(messages[`buttonGoToLesson`], { lessonNr: `${chapterNrInt}.1` }),
      };
    }

    return {
      id: chapter.id,
      number: chapter.publicId!,
      title: chapter.name,
      description: chapter.description || "",
      button,
      subsection: {
        title: intl.formatMessage(messages.subsectionLessonTitle),
        items: chapter.chapterLessons.map((lesson: ChapterLesson) => {
          return {
            number: `${chapterNrInt}.${lesson.lesson?.publicId}`,
            title: lesson.lesson.name,
            disabled: lesson.lesson.id ? false : true,
            href: `/course/spatial-audio/${lesson.lesson.id}`,
          };
        }),
      },

      muted: false,
    };
  });

  return {
    sections: [
      {
        title: intl.formatMessage(messages.menuWelcome),
        courses: [],
        mainItem: {
          id: "s1",
          title: intl.formatMessage(messages.welcomeTitle),
          description: intl.formatMessage(messages.welcomeDescription),
          button: {
            href: "/contents?screen=pc1",
            title: intl.formatMessage(messages.welcomeButtonTitle),
            disabled: false,
          },
          muted: false,
          number: "",
        },
      },

      {
        title: intl.formatMessage(messages.menuChapters),
        courses: chapters,
      },
      {
        title: intl.formatMessage(messages.menuPracticalContent),
        courses: [
          {
            id: "pc1",
            title: intl.formatMessage(messages.subsectionCaseStudiesTitle),
            description: intl.formatMessage(messages.caseStudiesDescription),
            button: {
              href: "/course/spatial-audio/live-music",
              title: intl.formatMessage(messages[`buttonGoToCase`]),
            },
            subsection: {
              title: intl.formatMessage(messages.subsectionCaseStudiesTitle),
              items: [
                {
                  title: intl.formatMessage(messages.case1Title),
                  href: "/course/spatial-audio/atmos-truck",
                  number: "1.",
                },
                {
                  title: intl.formatMessage(messages.case2Title),
                  href: "/course/spatial-audio/beyond-chaos",
                  number: "2.",
                  disabled: false,
                },
                {
                  title: intl.formatMessage(messages.case3Title),
                  href: "/course/spatial-audio/iko-and-gerriet",
                  number: "3.",
                },
                {
                  title: intl.formatMessage(messages.case4Title),
                  href: "/course/spatial-audio/strings-installation",
                  number: "4.",
                  disabled: false,
                },

                {
                  title: intl.formatMessage(messages.case5Title),
                  href: "/course/spatial-audio/spatial-audio-in-Friedrichstadt-Palast-berlin",
                  number: "5.",
                  disabled: true,
                },
                {
                  title: intl.formatMessage(messages.case6Title),
                  href: "/course/spatial-audio/spatial-audio-for-health",
                  number: "6.",
                  disabled: false,
                },
                {
                  title: intl.formatMessage(messages.case7Title),
                  href: "/course/spatial-audio/live-music",
                  number: "7.",
                  disabled: false,
                },
                {
                  title: intl.formatMessage(messages.case8Title),
                  href: "/course/spatial-audio/spatial-audio-in-automotive",
                  number: "8.",
                  disabled: false,
                },
              ],
            },
            number: "I",
            muted: false,
          },
          {
            id: "pc2",
            title: intl.formatMessage(messages.subsectionGuidesTitle),
            description: intl.formatMessage(messages.guidesDescription),
            button: {
              href: "/course/spatial-audio/channel-based-production-for-music",
              title: intl.formatMessage(messages[`buttonGoToGuideSoon`]),
              disabled: false,
            },
            subsection: {
              title: intl.formatMessage(messages.subsectionGuidesTitle),
              items: [
                // {
                //   title: intl.formatMessage(messages.guide1Title),
                //   number: "1.",
                //   disabled: true,
                // },
                {
                  title: intl.formatMessage(messages.guide2Title),
                  number: "1.",
                  href: "/course/spatial-audio/channel-based-production-for-music",
                },
                {
                  title: intl.formatMessage(messages.guide3Title),
                  number: "2.",
                  href: "/course/spatial-audio/dolby-atmos-mixing-for-home-cinema",
                },
                {
                  title: intl.formatMessage(messages.guide4Title),
                  number: "3.",
                  href: "/course/spatial-audio/ambisonic-sound-production-for-360-film",
                },
                {
                  title: intl.formatMessage(messages.guide5Title),
                  number: "4.",

                  href: "/course/spatial-audio/build-your-own-ambisonics-microphone-array",
                },
                {
                  title: intl.formatMessage(messages.guide6Title),
                  number: "5.",

                  href: "/course/spatial-audio/interactive-spatial-audio",
                },
              ],
            },
            number: "II",
            muted: false,
          },
        ],
      },
      {
        title: "Team",
        courses: [],
        mainItem: {
          id: "team",
          title: "Team",
          description: "",
          muted: false,
          number: "",
        },
      },
      {
        title: "Further Materials",
        courses: [],
        mainItem: {
          id: "further-materials",
          title: "Further Materials",
          description: "",
          muted: false,
          number: "",
          button: {
            href: "/course/spatial-audio/further-materials",
            title: intl.formatMessage(messages[`buttonGoToFurtherMaterials`]),
            disabled: false,
          },
        },
      },
    ],
  };
};
